<router-outlet></router-outlet>

<dx-load-panel #loadPanel [message]="this.glb.loadingText" shadingColor="rgba(0,0,0,0.4)"
  [indicatorSrc]="this.glb.indicatorUrl" [position]="{ of: '#employee' }" [(visible)]="this.glb.loadingVisible"
  [showIndicator]="true" [showPane]="true" [shading]="true" [closeOnOutsideClick]="false">
</dx-load-panel>